// extracted by mini-css-extract-plugin
export default {"wrapper":"AIHome_wrapper__hRUSk"};